import { jsx } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { SurveyCard } from "@brandclub/bc-widgets";
import StoreCarousel from "../StoreCarousel.js";
const SurveyCarousel = ({
  surveys,
  isLoading = false,
  onSurveyClick
}) => {
  const [isMobileView, setIsMobileView] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.innerWidth < 500;
  });
  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 500);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const cardWidth = isMobileView ? 240 : 280;
  if (isLoading && surveys.length === 0) {
    return /* @__PURE__ */ jsx("div", { className: "tw:w-full tw:my-4", children: /* @__PURE__ */ jsx(StoreCarousel, { children: [1, 2, 3].map((i) => /* @__PURE__ */ jsx(
      "div",
      {
        style: {
          width: cardWidth,
          height: 280,
          borderRadius: 16,
          backgroundColor: "#f3f4f6",
          animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite"
        }
      },
      i
    )) }) });
  }
  if (!surveys || surveys.length === 0) {
    return null;
  }
  return /* @__PURE__ */ jsx("div", { className: "tw:w-full tw:my-4", style: { padding: "8px 0" }, children: /* @__PURE__ */ jsx(StoreCarousel, { gap: 16, children: surveys.map((survey) => /* @__PURE__ */ jsx("div", { style: { padding: "4px" }, children: /* @__PURE__ */ jsx(
    SurveyCard,
    {
      survey: {
        campaignId: survey.campaignId,
        title: survey.title,
        brandName: survey.brandName,
        brandId: survey.brandId,
        brandLogoUrl: survey.brandLogoUrl,
        description: survey.description,
        rewardAmount: survey.rewardAmount,
        previewImageUrl: survey.previewImageUrl
      },
      width: cardWidth,
      onClick: onSurveyClick ? () => onSurveyClick(survey) : () => window.open(`/survey/${survey.campaignId}`, "_blank", "noopener")
    }
  ) }, survey.campaignId)) }) });
};
export {
  SurveyCarousel
};
//# sourceMappingURL=SurveyCarousel.js.map
